import { render, staticRenderFns } from "./CrearPuertaModal.vue?vue&type=template&id=04d7aa2e"
import script from "./CrearPuertaModal.vue?vue&type=script&lang=js"
export * from "./CrearPuertaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports